document.addEventListener('DOMContentLoaded', () => {
  // =====================================================
  // 🌍 GLOBAL CONSTANTS
  // =====================================================
  const _ukCalcLog = typeof window.createLogger === 'function'
    ? window.createLogger('UK Calculator')
    : { log: () => {}, warn: () => {}, error: () => {} };

  const cartData = window.CartItemsDataUK || {};
  var resolvedLocale = 'en-GB';
  var currency = 'GBP';

  let selectedCountryCode = cartData.destination || 'GB';
  let shippingRateCents = 0;

  // Calculate cart total without VAT ONCE at initialization based on initial country
  // This should NOT be recalculated when country changes
  let initialVatRate = getVatRate(selectedCountryCode);
  let initialVatDivisor = 1.0 + initialVatRate;
  let cartTotalWithVatCents = cartData.cartTotalWithVAT;
  let cartTotalWithoutVatCents = cartTotalWithVatCents / initialVatDivisor;

  _ukCalcLog.log('Initialized with cart data:', cartData);
  _ukCalcLog.log('Initial country:', selectedCountryCode);
  _ukCalcLog.log('Initial VAT rate:', initialVatRate);
  _ukCalcLog.log('Cart Total WITH VAT (cents):', cartTotalWithVatCents);
  _ukCalcLog.log('Cart Total WITHOUT VAT (cents):', cartTotalWithoutVatCents);

  /**
   * Update cart data from Shopify's cart response
   */
  function updateCartData(shopifyCart) {
    _ukCalcLog.log('Updating cart data from Shopify response:', shopifyCart);

    // Update cart total with VAT
    cartTotalWithVatCents = shopifyCart.total_price || 0;

    // Recalculate cart total without VAT using initial country's VAT rate
    initialVatRate = getVatRate(selectedCountryCode);
    initialVatDivisor = 1.0 + initialVatRate;
    cartTotalWithoutVatCents = cartTotalWithVatCents / initialVatDivisor;

    _ukCalcLog.log('Updated cart total WITH VAT:', cartTotalWithVatCents);
    _ukCalcLog.log('Updated cart total WITHOUT VAT:', cartTotalWithoutVatCents);
  }

  const totalPayableWithoutVatAmountDisplayUK = document.getElementById('total-payable-without-vat-amount-display-uk');
  const vatRateDisplayUK = document.getElementById('vat-rate-display-uk');
  const vatAmountDisplayUK = document.getElementById('vat-amount-display-uk');
  const landedTotalAmountDisplayUK = document.getElementById('landed-total-amount-display-uk');
  const shippingAmountDisplayUk = document.getElementById('shipping-amount-display-uk');

  // =====================================================
  // ✅ Listen for country selection the custom event fired from shipping-calculator.js
  // =====================================================

  window.addEventListener('UK-shipping-country-selected', function (event) {
    selectedCountryCode = event.detail.code;
    _ukCalcLog.log('Country changed to:', selectedCountryCode);
    shippingRateCents = 0; // Reset shipping when country changes
    calculate();
  });

  function calculate() {
    _ukCalcLog.log('Calculating for country:', selectedCountryCode, 'shipping:', shippingRateCents);

    // Get VAT rate for selected country
    const vatRate = getVatRate(selectedCountryCode);
    const vatPercent = vatRate * 100;
    const vat_divisor = 1.0 + vatRate;
    shippingRateCents = shippingRateCents / vat_divisor;

    // Calculate totals using pre-calculated cart total without VAT
    const totalWithShippingCents = cartTotalWithoutVatCents + shippingRateCents;
    const vatAmountCents = totalWithShippingCents * vatRate;
    const landedTotalCents = totalWithShippingCents + vatAmountCents;

    _ukCalcLog.log('Subtotal (excl VAT):', cartTotalWithoutVatCents);
    _ukCalcLog.log('Shipping:', shippingRateCents);
    _ukCalcLog.log('Total with shipping (excl VAT):', totalWithShippingCents);
    _ukCalcLog.log('VAT rate:', vatPercent + '%');
    _ukCalcLog.log('VAT amount:', vatAmountCents);
    _ukCalcLog.log('Landed total:', landedTotalCents);

    // Update DOM
    if (totalPayableWithoutVatAmountDisplayUK) {
      totalPayableWithoutVatAmountDisplayUK.textContent = formatMoney(cartTotalWithoutVatCents, {
        locale: resolvedLocale,
        currency: currency
      });
    }
    if (shippingAmountDisplayUk) {
      shippingAmountDisplayUk.textContent = formatMoney(shippingRateCents, {
        locale: resolvedLocale,
        currency: currency
      });
    }
    // Show/hide shipping row and divider based on value
    toggleElementVisibility('shipping-summary-uk', shippingRateCents > 0);
    toggleElementVisibility('uk-totals-divider', shippingRateCents > 0, 'block');
    if (vatRateDisplayUK) {
      vatRateDisplayUK.textContent = vatPercent.toFixed(0);
    }
    if (vatAmountDisplayUK) {
      vatAmountDisplayUK.textContent = formatMoney(vatAmountCents, { locale: resolvedLocale, currency: currency });
    }
    if (landedTotalAmountDisplayUK) {
      landedTotalAmountDisplayUK.textContent = formatMoney(landedTotalCents, {
        locale: resolvedLocale,
        currency: currency
      });
    }
  }

  // =====================================================
  // ✅ UK Shipping rate selection event
  // =====================================================
  window.addEventListener('UK-shipping-rate-selected', function (event) {
    const shipping = event.detail.shipping;

    _ukCalcLog.log('Shipping selected:', shipping.name, shipping.price, 'for', event.detail.code);

    selectedCountryCode = event.detail.code;
    shippingRateCents = Number(shipping.price) * 100;

    calculate();
  });

  // =====================================================
  // ✅ Listen for custom cart processed event from forklift (single source of truth)
  // =====================================================
  window.addEventListener('cart-forklift-processed', (event) => {
    try {
      _ukCalcLog.log('Cart processed by forklift, recalculating totals');

      // Update cart data from the event
      if (event.detail && event.detail.cartData) {
        updateCartData(event.detail.cartData);
        calculate();
      } else {
        _ukCalcLog.warn('No cart data in forklift event');
      }
    } catch (err) {
      _ukCalcLog.warn('Cart forklift processed event error:', err);
    }
  });

  _ukCalcLog.log('Listening to cart-forklift-processed events (single source of truth)');

  /**
   * Helper function to show/hide DOM element
   */
  function toggleElementVisibility(id, shouldShow, displayValue) {
    const element = document.getElementById(id);
    if (element) {
      element.style.display = shouldShow ? (displayValue || 'flex') : 'none';
    }
  }

  // Run initial calculation
  calculate();
});
